import styles from './ButtonPrincipal.module.css';

export default function ButtonPrincipal({ children, tamanho }) {
    return (
        <button className={`
            ${styles.buttonPrincipal}
            ${styles[tamanho]}
        `}>
            {children}
        </button>
    )
}